document.addEventListener('DOMContentLoaded', function () {
  const openButton = document.querySelector('.custom-header__icon-button');
  const closeButton = document.querySelector('.mobile-menu__close');
  const mobileMenu = document.querySelector('.mobile-menu');

  if (!openButton || !closeButton || !mobileMenu) return;

  openButton.addEventListener('click', function () {
    mobileMenu.classList.add('is-active');
  });

  closeButton.addEventListener('click', function () {
    mobileMenu.classList.remove('is-active');
  });
});